import React from 'react'
import './modal-sizes.scss'

import iconSize from '../../../assets/images/icon-size.svg'
import iconSizeTwo from '../../../assets/images/icon-size-two.svg'
import { textChange } from '../../../constants/activity-constants'


const ModalSizes = props => {
  const { setShowModal } = props

  return (
    <div className="f-Modal-size">
      <div className="f-Modal-size__content">
        <span
          className="f-Modal-size__content-close"
          onClick={() => {
            setShowModal(false)
            try {
                window.dataLayer.push({
                  event: 'ga_event',
                  category: 'ui :: popup :: encuentra tu talla',
                  action: 'click',
                  label: 'cerrar popup',
                  value: '',
                })
              } catch (error) {
                console.log(error)
              }
          }}
        />

        <h2>Encuentra tu talla ideal</h2>

        <div className="f-Modal-size__content-info">
          <img src={iconSize} alt="icon-size" />
          <div className="f-Modal-size__content-info-text">
            <h3>¿Cómo medir?</h3>
            <p>
              {textChange.text_12}
            </p>
          </div>
        </div>

        <div className="f-Modal-size__content-sizes">
          <div className="f-Modal-size__content-sizes-size">
            <span>S</span>
            <img src={iconSizeTwo} alt="icon-size-s" />
            <p>75cm-95cm cadera</p>
          </div>
          <div className="f-Modal-size__content-sizes-size">
            <span>M</span>
            <img src={iconSizeTwo} alt="icon-size-m" />
            <p>90cm-105cm cadera</p>
          </div>
          <div className="f-Modal-size__content-sizes-size">
            <span>L/XL</span>
            <img src={iconSizeTwo} alt="icon-size-sl/xl" />
            <p>105cm-115cm cadera</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ModalSizes
